import Divider from '@base/Divider/Divider';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';

const PriceBreakDownTableWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  border: 1px solid var(--color-i-divider);
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_0B} ${Spacings.SPACING_3B}
    ${Spacings.SPACING_3B};
`;

const BreakDownWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-right: ${Spacings.SPACING_3B};
`;

const SinglePriceDistributionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6};
`;

const BreakDown = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const FinalPrice = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const FinalPriceBreakDown = styled(BreakDown)`
  padding-right: ${Spacings.SPACING_3B};
`;

const StyDivider = styled(Divider)`
  margin: ${Spacings.SPACING_2B} ${Spacings.SPACING_0B} ${Spacings.SPACING_2B};
`;

const POSITIVE = 'positive';

const PriceBreakDownTable = ({ priceBreakDown }) => {
  const hasMultiplePrice = priceBreakDown?.length > 1;
  return hasMultiplePrice ? (
    <PriceBreakDownTableWrapper>
      <BreakDownWrapper>
        {priceBreakDown
          .slice(0, priceBreakDown?.length - 1)
          .map((priceArray, index) => {
            return (
              <>
                <SinglePriceDistributionWrapper>
                  {priceArray?.map((price) => {
                    const isPositivePrice = price?.type === POSITIVE;
                    return (
                      <BreakDown key={price.name}>
                        <Typography
                          variant="p3"
                          color={
                            isPositivePrice
                              ? 'var(--color-i-black)'
                              : 'var(--color-i-gray-13)'
                          }
                        >
                          {price.name}
                        </Typography>
                        <Typography
                          variant="p3"
                          color={
                            isPositivePrice
                              ? 'var(--color-i-black)'
                              : 'var(--color-i-gray-13)'
                          }
                        >
                          {price.price}
                        </Typography>
                      </BreakDown>
                    );
                  })}
                </SinglePriceDistributionWrapper>
                {index + 1 !== priceBreakDown?.length - 1 && <StyDivider />}
              </>
            );
          })}
      </BreakDownWrapper>
      <StyDivider />
      <FinalPriceBreakDown>
        <Typography variant="h6">
          {priceBreakDown[priceBreakDown?.length - 1] &&
            priceBreakDown[priceBreakDown?.length - 1][0]?.name}
        </Typography>
        <Typography variant="h6">
          {priceBreakDown[priceBreakDown?.length - 1] &&
            priceBreakDown[priceBreakDown?.length - 1][0]?.price}
        </Typography>
      </FinalPriceBreakDown>
    </PriceBreakDownTableWrapper>
  ) : (
    <FinalPrice>
      <Typography variant="h6">
        {priceBreakDown[priceBreakDown?.length - 1] &&
          priceBreakDown[priceBreakDown?.length - 1][0]?.name}
      </Typography>
      <Typography variant="h6">
        {priceBreakDown[priceBreakDown?.length - 1] &&
          priceBreakDown[priceBreakDown?.length - 1][0]?.price}
      </Typography>
    </FinalPrice>
  );
};

export default PriceBreakDownTable;
